import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import { AssignmentReleaseStateFragmentDoc, AssignmentGradingCountsFragmentDoc } from './assignmentGradingCounts.queries.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TeacherAssignmentRowFieldsFragment = { __typename?: 'Assignment', id: string, name: string, teacherId?: string | null, updatedAt: any, educatorStatus: Types.AssignmentStatus, minDueDate?: any | null, maxDueDate?: any | null, minStartDate?: any | null, maxStartDate?: any | null, countOfCompletedStudents: number, countOfIncompleteStudents: number, countOfSubmittedManuallyGradedGuesses: number, countOfUngradedGuesses: number, countOfGradingInProgressGuesses: number, countOfReleasableGradedGuesses: number, classroomAssignments: Array<{ __typename?: 'ClassroomAssignment', id: string, classroomId: string, gradesReleased?: boolean | null }> };

export type TeacherAssignmentStatusCountsQueryVariables = Types.Exact<{
  allFilter?: Types.InputMaybe<Types.AssignmentFilterInput>;
  openFilter?: Types.InputMaybe<Types.AssignmentFilterInput>;
  closedFilter?: Types.InputMaybe<Types.AssignmentFilterInput>;
  scheduledFilter?: Types.InputMaybe<Types.AssignmentFilterInput>;
  draftFilter?: Types.InputMaybe<Types.AssignmentFilterInput>;
  asEducatorId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type TeacherAssignmentStatusCountsQuery = { __typename?: 'RootQueryType', all?: { __typename?: 'KeysetPageOfAssignment', count?: number | null } | null, open?: { __typename?: 'KeysetPageOfAssignment', count?: number | null } | null, closed?: { __typename?: 'KeysetPageOfAssignment', count?: number | null } | null, scheduled?: { __typename?: 'KeysetPageOfAssignment', count?: number | null } | null, draft?: { __typename?: 'KeysetPageOfAssignment', count?: number | null } | null };

export type TeacherAssignmentsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.AssignmentFilterInput>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.AssignmentSortInput>> | Types.InputMaybe<Types.AssignmentSortInput>>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  classroomIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  asEducatorId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  includeGradingCounts: Types.Scalars['Boolean']['input'];
}>;


export type TeacherAssignmentsQuery = { __typename?: 'RootQueryType', assignmentsAsEducator?: { __typename?: 'KeysetPageOfAssignment', count?: number | null, endKeyset?: string | null, results?: Array<{ __typename?: 'Assignment', id: string, name: string, teacherId?: string | null, updatedAt: any, educatorStatus: Types.AssignmentStatus, minDueDate?: any | null, maxDueDate?: any | null, minStartDate?: any | null, maxStartDate?: any | null, countOfCompletedStudents: number, countOfIncompleteStudents: number, countOfSubmittedManuallyGradedGuesses: number, countOfUngradedGuesses: number, countOfGradingInProgressGuesses: number, countOfReleasableGradedGuesses: number, classroomAssignments: Array<{ __typename?: 'ClassroomAssignment', id: string, classroomId: string, gradesReleased?: boolean | null }> }> | null } | null };

export const TeacherAssignmentRowFieldsFragmentDoc = gql`
    fragment TeacherAssignmentRowFields on Assignment {
  id
  name
  teacherId
  updatedAt
  educatorStatus(classroomIds: $classroomIds)
  minDueDate(classroomIds: $classroomIds)
  maxDueDate(classroomIds: $classroomIds)
  minStartDate(classroomIds: $classroomIds)
  maxStartDate(classroomIds: $classroomIds)
  countOfCompletedStudents(classroomIds: $classroomIds)
  countOfIncompleteStudents(classroomIds: $classroomIds)
  ...AssignmentGradingCounts @include(if: $includeGradingCounts)
  ...AssignmentReleaseState @include(if: $includeGradingCounts)
}
    ${AssignmentGradingCountsFragmentDoc}
${AssignmentReleaseStateFragmentDoc}`;
export const TeacherAssignmentStatusCountsDocument = gql`
    query TeacherAssignmentStatusCounts($allFilter: AssignmentFilterInput, $openFilter: AssignmentFilterInput, $closedFilter: AssignmentFilterInput, $scheduledFilter: AssignmentFilterInput, $draftFilter: AssignmentFilterInput, $asEducatorId: ID) {
  all: assignmentsAsEducator(
    filter: $allFilter
    first: 1
    asEducatorId: $asEducatorId
  ) {
    count
  }
  open: assignmentsAsEducator(
    filter: $openFilter
    first: 1
    asEducatorId: $asEducatorId
  ) {
    count
  }
  closed: assignmentsAsEducator(
    filter: $closedFilter
    first: 1
    asEducatorId: $asEducatorId
  ) {
    count
  }
  scheduled: assignmentsAsEducator(
    filter: $scheduledFilter
    first: 1
    asEducatorId: $asEducatorId
  ) {
    count
  }
  draft: assignmentsAsEducator(
    filter: $draftFilter
    first: 1
    asEducatorId: $asEducatorId
  ) {
    count
  }
}
    `;

/**
 * __useTeacherAssignmentStatusCountsQuery__
 *
 * To run a query within a React component, call `useTeacherAssignmentStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherAssignmentStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherAssignmentStatusCountsQuery({
 *   variables: {
 *      allFilter: // value for 'allFilter'
 *      openFilter: // value for 'openFilter'
 *      closedFilter: // value for 'closedFilter'
 *      scheduledFilter: // value for 'scheduledFilter'
 *      draftFilter: // value for 'draftFilter'
 *      asEducatorId: // value for 'asEducatorId'
 *   },
 * });
 */
export function useTeacherAssignmentStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherAssignmentStatusCountsQuery, TeacherAssignmentStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherAssignmentStatusCountsQuery, TeacherAssignmentStatusCountsQueryVariables>(TeacherAssignmentStatusCountsDocument, options);
      }
export function useTeacherAssignmentStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherAssignmentStatusCountsQuery, TeacherAssignmentStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherAssignmentStatusCountsQuery, TeacherAssignmentStatusCountsQueryVariables>(TeacherAssignmentStatusCountsDocument, options);
        }
// @ts-ignore
export function useTeacherAssignmentStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeacherAssignmentStatusCountsQuery, TeacherAssignmentStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherAssignmentStatusCountsQuery, TeacherAssignmentStatusCountsQueryVariables>;
export function useTeacherAssignmentStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherAssignmentStatusCountsQuery, TeacherAssignmentStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherAssignmentStatusCountsQuery | undefined, TeacherAssignmentStatusCountsQueryVariables>;
export function useTeacherAssignmentStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherAssignmentStatusCountsQuery, TeacherAssignmentStatusCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeacherAssignmentStatusCountsQuery, TeacherAssignmentStatusCountsQueryVariables>(TeacherAssignmentStatusCountsDocument, options);
        }
export type TeacherAssignmentStatusCountsQueryHookResult = ReturnType<typeof useTeacherAssignmentStatusCountsQuery>;
export type TeacherAssignmentStatusCountsLazyQueryHookResult = ReturnType<typeof useTeacherAssignmentStatusCountsLazyQuery>;
export type TeacherAssignmentStatusCountsSuspenseQueryHookResult = ReturnType<typeof useTeacherAssignmentStatusCountsSuspenseQuery>;
export type TeacherAssignmentStatusCountsQueryResult = Apollo.QueryResult<TeacherAssignmentStatusCountsQuery, TeacherAssignmentStatusCountsQueryVariables>;
export const TeacherAssignmentsDocument = gql`
    query TeacherAssignments($filter: AssignmentFilterInput, $sort: [AssignmentSortInput], $first: Int, $after: String, $classroomIds: [ID!], $asEducatorId: ID, $includeGradingCounts: Boolean!) {
  assignmentsAsEducator(
    filter: $filter
    sort: $sort
    first: $first
    after: $after
    asEducatorId: $asEducatorId
  ) {
    count
    endKeyset
    results {
      ...TeacherAssignmentRowFields
    }
  }
}
    ${TeacherAssignmentRowFieldsFragmentDoc}`;

/**
 * __useTeacherAssignmentsQuery__
 *
 * To run a query within a React component, call `useTeacherAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherAssignmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      classroomIds: // value for 'classroomIds'
 *      asEducatorId: // value for 'asEducatorId'
 *      includeGradingCounts: // value for 'includeGradingCounts'
 *   },
 * });
 */
export function useTeacherAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables> & ({ variables: TeacherAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>(TeacherAssignmentsDocument, options);
      }
export function useTeacherAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>(TeacherAssignmentsDocument, options);
        }
// @ts-ignore
export function useTeacherAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>;
export function useTeacherAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherAssignmentsQuery | undefined, TeacherAssignmentsQueryVariables>;
export function useTeacherAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>(TeacherAssignmentsDocument, options);
        }
export type TeacherAssignmentsQueryHookResult = ReturnType<typeof useTeacherAssignmentsQuery>;
export type TeacherAssignmentsLazyQueryHookResult = ReturnType<typeof useTeacherAssignmentsLazyQuery>;
export type TeacherAssignmentsSuspenseQueryHookResult = ReturnType<typeof useTeacherAssignmentsSuspenseQuery>;
export type TeacherAssignmentsQueryResult = Apollo.QueryResult<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>;